<div *ngIf="{ mapIsShown: mapIsShown$ | async } as obs" class="map-wrapper">
  <div class="address-form-buttons">
    <button (click)="toggle()" class="btn btn-map btn-default btn-link">
      <cx-icon class="icon" [type]="iconType.POINT"></cx-icon>

      {{ obs.mapIsShown ? 'Скрыть карту' : 'Найти на карте' }}
    </button>
  </div>
  <div *ngIf="!obs.mapIsShown">
    <ui-address-suggestions-select
      (changeAddress)="onChangeAddress($event)"
      label="Куда будем доставлять?"
    ></ui-address-suggestions-select>
  </div>
  <div [ngClass]="{ hide: obs.mapIsShown }" #shopListRef class="shoplist">
    <div
      *ngFor="let item of shopsSorted$ | async"
      id="id{{ item.name }}"
      (click)="confirmShop(item.name)"
      [ngClass]="{ active: item.name === (activeId$ | async) }"
      class="shop"
    >
      <ng-container
        *ngIf="shopTemplateRef"
        [ngTemplateOutlet]="shopTemplateRef"
        [ngTemplateOutletContext]="{ $implicit: item }"
      ></ng-container>
    </div>
  </div>
  <div class="shop-map-container" [ngClass]="{ hide: !obs.mapIsShown }">
    <sd-shops-map
      *ngIf="environmentService.isPlatformBrowser"
      [shops]="shopList"
      class="map-pickup"
      [getShopPlacemarkProperties]="getShopPlacemarkProperties"
      (created)="onMapCreated($event)"
    ></sd-shops-map>
  </div>
</div>
